// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"vvITp","header":"_2dlTv","content":"ZvIh9","expanded":"_2Ntjc","title":"gREyf"};